<!-- Full Width Container -->
<div class="py-8">

	<!-- Centered Content Box -->
	<div class="pixel-9-slice">
		<div class="max-w-4xl mx-auto bg-base-100 p-8 min-h-[600px] sm:pb-[0px] pb-[170px]">
			<h2>GET STARTED</h2>
			<p class="text-base-content/60 text-xs mt-2 mb-8">Create a new account to get started.</p>

			<div class="flex justify-start">
				<button type="button" (click)="goToSignup()"
					class="red-cta-btn-xlg retro-pixel-regular mb-5">
					<span>SIGN UP</span>
				</button>
			</div>

			<hr class="border-t-4 border-gray-300 my-8">

			<!-- Welcome Back Header -->
			<h2>SIGN IN</h2>
			<p class="text-base-content/60 text-xs mt-2 mb-4">Sign in to an existing account to continue.</p>

			<!-- Error Message -->
			@if (errorMessage()) {
			<div class="bg-error/10 border border-error text-error p-3 rounded mb-4">
				{{ errorMessage() }}
			</div>
			}

			<!-- Login Form -->
			<form (ngSubmit)="onSubmit()" #loginForm="ngForm">
				<!-- Email Field -->
				<div class="mb-5">
					<label for="email" class="block mb-1.5 text-base-content font-medium">Email Address</label>
					<input type="email" id="email" name="email" [(ngModel)]="email" required
						class="w-full p-3 border-2 rounded"
						[class.border-error]="loginForm.form.get('email')?.invalid && loginForm.form.get('email')?.touched"
						[class.border-base-300]="!(loginForm.form.get('email')?.invalid && loginForm.form.get('email')?.touched)"
						placeholder="Enter email" (blur)="loginForm.form.get('email')?.markAsTouched()">
				</div>

				<!-- Password Field -->
				<div class="mb-5">
					<label for="password" class="block mb-1.5 text-base-content font-medium">Password</label>
					<div class="relative">
						<input [type]="showPassword() ? 'text' : 'password'" id="password" name="password"
							[(ngModel)]="password" required class="w-full p-3 pr-12 border-2 rounded"
							[class.border-error]="loginForm.form.get('password')?.invalid && loginForm.form.get('password')?.touched"
							[class.border-base-300]="!(loginForm.form.get('password')?.invalid && loginForm.form.get('password')?.touched)"
							placeholder="Enter password" (blur)="loginForm.form.get('password')?.markAsTouched()">
						<button type="button" (click)="togglePasswordVisibility()"
							class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-transparent border-none cursor-pointer text-base-content/60 p-0">
							@if (showPassword()) {
							<eye-slash-icon [color]="'currentColor'" [size]="20"></eye-slash-icon>
							} @else {
							<eye-icon [color]="'currentColor'" [size]="20"></eye-icon>
							}
						</button>
					</div>
				</div>

				<!-- Forgot Password Link -->
				<div class="mb-6">
					<button type="button" (click)="goToForgotPassword()"
						class="bg-transparent border-none text-primary cursor-pointer text-sm">
						Forgot your password?
					</button>
				</div>

				<!-- Submit Button -->
				<button type="submit" [disabled]="isLoading() || loginForm.form.invalid"
					class="yellow-cta-btn-xlg retro-pixel-regular mb-5">
					@if (isLoading()) {
					<span>LOADING</span>
					} @else {
					<span>SIGN IN</span>
					}
				</button>
			</form>

		</div>
	</div>

	<!-- Overlaid Crustopher -->
	<div class="crustopher-overlay">
		<img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
	</div>

</div>